import "./index.css";
import { Avatar, useBoolean } from "@/ui-kit";
import { MobileMenu } from "../Menu";
import { useAppStore } from "@/store/app/slice";
import { useBreakpoints } from "@/hooks/useBreakpoints";
import { UserLoadingStatus } from "@/types/users";

export const MobileMenuToggle = () => {
  const user = useAppStore((s) => s.user);
  const userLoaded = useAppStore((s) => s.userLoaded);
  const { isMobile } = useBreakpoints();

  const {
    value: isOpen,
    setTrue: openMenu,
    setFalse: dismissMenu,
  } = useBoolean(false);

  if (!isMobile) {
    return null;
  }

  return (
    <>
      <button className="mobile-menu__toggle-button" onClick={openMenu}>
        <Avatar
          size="md"
          text={user?.fullName}
          src={user?.profilePicturePath}
          loading={userLoaded !== UserLoadingStatus.Loaded}
          showDetails={false}
        />
      </button>
      <MobileMenu isOpen={isOpen} onDismiss={dismissMenu} />
    </>
  );
};
